import { render, staticRenderFns } from "./PlainNoteContent.vue?vue&type=template&id=2a882b04&scoped=true&"
import script from "./PlainNoteContent.vue?vue&type=script&lang=js&"
export * from "./PlainNoteContent.vue?vue&type=script&lang=js&"
import style0 from "./PlainNoteContent.vue?vue&type=style&index=0&id=2a882b04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a882b04",
  null
  
)

export default component.exports